import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={46}
      height={45}
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect
        x={0.575195}
        width={44.8501}
        height={44.8501}
        rx={22.425}
        fill="#E9FCE1"
      />
      <Path
        d="M14.03 22.76l5.3 5.271 11.52-12.334"
        stroke="#198155"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default SvgComponent;
